window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('select2');
require('owl.carousel2');
require('swipebox');

require('./js/front/site-loader');
require('./js/front/magic-cols');
require('./js/front/main');

// document.querySelectorAll('.label-preview').forEach(function (element) {
//   $.post("https://luckylabels-crm.best4utech.nl/api/test-server-side", {
//     first_name: element.dataset.first_name,
//     last_name: element.dataset.last_name,
//     image: element.dataset.image,
//     background: element.dataset.background,
//     font: element.dataset.font,
//     text_color: element.dataset.text_color,
//     model: element.dataset.model
//   })
//     .done(function(data) {
//       element.innerHTML = data;
//       let scale = Math.min(
//         $(element.parentNode.parentNode).width() / $(element).find(".labelBlock").width(),
//         $(element.parentNode.parentNode).height() / $(element).find(".labelBlock").height()
//       );
//       $(element).find(".labelBlock").css({
//         transform: "scale(" + scale + ")",
//         'transform-origin': "left"
//       });
//     });
// });